var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-space-between":"","align-center":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":""}},[_c('h3',{staticClass:"text-xs-left"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_c('div',[_vm._t("leftElem")],2)]),_c('div',{style:({position:'relative'})},[_c('div',{style:({
          position:'absolute',
          top: '0',
          left: '0',
          transform: 'translate(-100%, -50%)',
        })},[_vm._t("rightElem")],2)])],1),_c('app-view-spacer',{attrs:{"mtop":'0'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }